/**
 * Entrypoint for the new Giftly corporate portal.
 *
 * This script is included in the corporate layout, which is used by InertiaRails.
 */
import '@corp_public/styles/global.scss'
import 'virtual:uno.css'
import { createApp } from '@shared/app'
import pages from '@corp_public/pages'

createApp('corporate_public', pages)
